import { PageRequest } from '@/core/request/PageRequest';

export enum PurchasesRequestColumn {
  workOrder = 'domain.enums.order_by_request_purchase.work_order',
  licensePlate = 'domain.enums.order_by_request_purchase.license_plate',
  manufacturingCode = 'domain.enums.order_by_request_purchase.manufacturing_code',
  barCode = 'domain.enums.order_by_request_purchase.barCode',
  companyCode = 'domain.enums.order_by_request_purchase.companyCode',
  internalCode = 'domain.enums.order_by_request_purchase.internalCode',
  sku = 'domain.enums.order_by_request_purchase.sku',
  description = 'domain.enums.order_by_request_purchase.description',
}

export enum RequestPurchaseItemType {
  part = 'domain.enums.work_order_item_type.part',
  task = 'domain.enums.work_order_item_type.service',
}

export const RequestPurchaseItemTypeLabel = {
  [RequestPurchaseItemType.part]: 'Peça',
  [RequestPurchaseItemType.task]: 'Serviço',
};

export const RequestPurchaseItemTypeColor = {
  [RequestPurchaseItemType.part]: 'blue',
  [RequestPurchaseItemType.task]: 'yellow',
};

export interface RequestPurchases {
  id: number;
  workItemId: number;
  complementId: number;
  workOrderNumber: string;
  description: string;
  licensePlate: string;
  type: RequestPurchaseItemType;
  quantityPurchased: number;
  requestedQuantity: number;
  quantitySentPurchased: number;
  quantityQuotation: number;
  total: number;
  item: ItemRequestPurchase;
  workOrderUnitCost: number;
}

export interface ItemRequestPurchase {
  id: number;
  manufacturerId: number;
  manufacturingCode: string;
  unit: string;
  unitPrice: number;
  cfopId?: number;
  ncmId?: number;
}

export enum RequestPurchaseFieldOption {
  workOrder = 'domain.enums.item_field_options.workOrder',
  licensePlate = 'domain.enums.item_field_options.licensePlate',
  manufacturingCode = 'domain.enums.item_field_options.manufacturingCode',
  barCode = 'domain.enums.order_by_request_purchase.barCode',
  companyCode = 'domain.enums.order_by_request_purchase.companyCode',
  internalCode = 'domain.enums.order_by_request_purchase.internalCode',
  sku = 'domain.enums.order_by_request_purchase.sku',
  description = 'domain.enums.item_field_options.description',
  quantity = 'domain.enums.item_field_options.quantity',
}

export enum RequestPurchaseType {
  undefined = 'domain.enums.item_type.undefined',
  part = 'domain.enums.item_type.part',
  consumable = 'domain.enums.item_type.consumable',
}

export interface RequestPurchasesQuery extends PageRequest {
  search?: string;
  licensePlateFilter?: string;
  workOrderFilter?: string;
  descriptionFilter?: string;
  manufacturingCodeFilter?: string;
  orderByPurchaseQuotation?: PurchasesRequestColumn;
  companyIdFilter?: number;
  type?: RequestPurchaseType;
}

export const RequestPurchaseColumnConfig: Record<
  string,
  PurchasesRequestColumn
> = {
  [RequestPurchaseFieldOption.workOrder]: PurchasesRequestColumn.workOrder,
  [RequestPurchaseFieldOption.licensePlate]:
    PurchasesRequestColumn.licensePlate,
  [RequestPurchaseFieldOption.manufacturingCode]:
    PurchasesRequestColumn.manufacturingCode,
  [RequestPurchaseFieldOption.barCode]: PurchasesRequestColumn.barCode,
  [RequestPurchaseFieldOption.sku]: PurchasesRequestColumn.sku,
  [RequestPurchaseFieldOption.internalCode]:
    PurchasesRequestColumn.internalCode,
  [RequestPurchaseFieldOption.companyCode]: PurchasesRequestColumn.companyCode,
  [RequestPurchaseFieldOption.description]: PurchasesRequestColumn.description,
};
